import { SequencerInstruction } from './sequence';

export const TICK_MS = 50;

export interface SoundGroupTimelineEntry {
  type: 'sound-group';
  atMs: number;
  instructionIds: string[];
}

export interface DelayTimelineEntry {
  type: 'delay';
  atMs: number;
  instructionId: string;
  durationMs: number;
}

export type SequenceTimelineEntry = SoundGroupTimelineEntry | DelayTimelineEntry;

export function buildSequenceTimeline(instructions: SequencerInstruction[]): SequenceTimelineEntry[] {
  const timeline: SequenceTimelineEntry[] = [];
  let cursorMs = 0;
  let pendingSoundIds: string[] = [];

  for (const instruction of instructions) {
    if (instruction.type === 'sound') {
      pendingSoundIds.push(instruction.id);
      continue;
    }

    flushSoundGroup();

    const durationMs = instruction.ticks * TICK_MS;
    timeline.push({
      type: 'delay',
      atMs: cursorMs,
      instructionId: instruction.id,
      durationMs,
    });
    cursorMs += durationMs;
  }

  flushSoundGroup();
  return timeline;

  function flushSoundGroup() {
    if (!pendingSoundIds.length) return;

    timeline.push({
      type: 'sound-group',
      atMs: cursorMs,
      instructionIds: pendingSoundIds,
    });
    pendingSoundIds = [];
  }
}
